import { render, staticRenderFns } from "./buyRiskDialog.vue?vue&type=template&id=1cc7e02c&scoped=true"
import script from "./buyRiskDialog.vue?vue&type=script&lang=js"
export * from "./buyRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./buyRiskDialog.vue?vue&type=style&index=0&id=1cc7e02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7e02c",
  null
  
)

export default component.exports